import { useState } from 'react';

// material-ui
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useColorScheme } from '@mui/material/styles';

// project imports
import IconButton from 'components/@extended/IconButton';

// assets
import SunOutlined from '@ant-design/icons/SunOutlined';
import MoonOutlined from '@ant-design/icons/MoonOutlined';
import DesktopOutlined from '@ant-design/icons/DesktopOutlined';

const OPCOES = [
  { mode: 'light', label: 'Claro', Icon: SunOutlined },
  { mode: 'dark', label: 'Escuro', Icon: MoonOutlined },
  { mode: 'system', label: 'Sistema', Icon: DesktopOutlined }
] as const;

// ==============================|| HEADER CONTENT - TEMA (CLARO / ESCURO / SISTEMA) ||============================== //

export default function ThemeToggle() {
  const { mode, setMode } = useColorScheme();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  const atual = OPCOES.find((o) => o.mode === mode) ?? OPCOES[0];
  const TriggerIcon = atual.Icon;

  return (
    <Box sx={{ flexShrink: 0 }}>
      <Tooltip title="Tema">
        <IconButton
          color="secondary"
          variant="light"
          sx={{ color: 'text.primary', bgcolor: anchor ? 'secondary.lighter' : 'transparent' }}
          aria-label="alternar tema"
          onClick={(e) => setAnchor(e.currentTarget)}
        >
          <TriggerIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchor}
        open={!!anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {OPCOES.map((o) => {
          const ativo = mode === o.mode;
          return (
            <MenuItem key={o.mode} selected={ativo} onClick={() => { setMode(o.mode); setAnchor(null); }} sx={{ minWidth: 160 }}>
              <ListItemIcon sx={{ minWidth: 32, color: ativo ? 'primary.main' : 'inherit' }}><o.Icon /></ListItemIcon>
              <ListItemText primaryTypographyProps={{ color: ativo ? 'primary.main' : 'inherit', fontWeight: ativo ? 600 : 400 }}>
                {o.label}
              </ListItemText>
            </MenuItem>
          );
        })}
      </Menu>
    </Box>
  );
}
